import { NgClass } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { IconComponent } from '@atoms/icon/icon.component';
import { ImageComponent } from '@atoms/image/image.component';
import { InputErrorComponent } from '@atoms/input-error/input-error.component';
import { TagComponent } from '@atoms/tag/tag.component';
import { MakeModelDropdownComponent } from '@dropdowns/make-model-dropdown/make-model-dropdown.component';
import { MakeModelDropdownSingleOutput } from '@models/make-mode-dropdown.model';
import { ModelDropdownValue } from '@models/model-dropdown.model';

@Component({
  selector: 'app-make-model-single',
  imports: [NgClass, IconComponent, ImageComponent, InputErrorComponent, TagComponent, MakeModelDropdownComponent],
  templateUrl: './make-model-single.component.html',
  styleUrl: './make-model-single.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MakeModelSingleComponent),
    },
  ],
})
export class MakeModelSingleComponent implements ControlValueAccessor {
  @Input() active?: MakeModelDropdownSingleOutput;
  @Input() error: boolean = false;
  @Input('error-message') errorMessage?: string;
  @Input('other-options') otherOptions: boolean = false;
  @Output() activeChange = new EventEmitter<MakeModelDropdownSingleOutput | undefined>();
  public value: ModelDropdownValue = {};
  public onChange = (value: MakeModelDropdownSingleOutput | undefined) => {};
  public onTouched = (value: boolean) => {};

  setActive(event: MakeModelDropdownSingleOutput): void {
    this.active = event;
    this.activeChange.emit(this.active);
    this.onChange(this.active);
  }

  remove(): void {
    this.value = {};
    this.active = undefined;
    this.activeChange.emit(this.active);
    this.onChange(this.active);
  }

  writeValue(obj: MakeModelDropdownSingleOutput | undefined | null): void {
    this.active = obj === null ? undefined : obj;
    if (!this.active) this.value = {};
    else this.value = { [this.active.makeId]: { id: this.active.makeId, models: [this.active.modelId], selectedAll: false } };
  }

  touch(): void {
    this.onTouched(true);
  }

  registerOnChange(fn: (value: MakeModelDropdownSingleOutput | undefined) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: boolean) => void): void {
    this.onTouched = fn;
  }
}
